@if ((ids()?.length && isLoading()) || resolvedItems()?.length) {
  <div class="container">
    @if (type()) {
      <h3 class="related-title">
        @switch (type()) {
          @case ('linkedProducts') {
            {{ 'products_preview.linked_products' | translate }}
          }
          @case ('recentlyViewedProducts') {
            {{ 'products_preview.recently_viewed_products' | translate }}
          }
          @case ('recentlyAddedProducts') {
            {{ 'products_preview.recently_added_products' | translate }}
          }
        }
      </h3>
    }

    <div class="related">
      <div class="related-carousel carousel">
        @if (isArrowVisible()) {
          <button (click)="prev()">
            <svg
              class="carousel-arrow carousel-arrow-prev"
               version="1.1" id="Layer_1"
               xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
               viewBox="0 0 495 495" style="enable-background:new 0 0 495 495;" xml:space="preserve"
            >
              <g>
                <path style="fill:#f3e1bd;" d="M247.5,0v140.444l24.483-24.563l28.33,28.238L247.5,197.105v100.789l52.813,52.986l-28.33,28.238
                  L247.5,354.556V495C384.19,495,495,384.19,495,247.5S384.19,0,247.5,0z"/>
                <path style="fill:#f8ca68;" d="M140.792,247.5L247.5,140.444V0C110.81,0,0,110.81,0,247.5S110.81,495,247.5,495V354.556
                  L140.792,247.5z"/>
                <polygon
                  style="fill:#f3e1bd;"
                  points="247.5,297.895 247.5,197.105 197.269,247.5 	"
                />
                <polygon style="fill:#ffffff;" points="247.5,354.556 271.983,379.119 300.313,350.881 247.5,297.895 197.269,247.5 247.5,197.105
                  300.313,144.119 271.983,115.881 247.5,140.444 140.792,247.5 	"/>
              </g>
            </svg>
          </button>
        }

        <div class="carousel-items-container">
          <div
            class="carousel-items"
            #itemsContainerRef
          >
            @for (item of resolvedItems(); track item.id) {
              <div
                class="carousel-item"
                 (touchstart)="swipe($event, 'start')"
                 (touchend)="swipe($event, 'end')"
                 #itemRef
              >
                <product-list-item
                  [item]="item"
                  [parentNameForAnalytics]="parentNameForAnalytics()"
                  (showCart)="showCart.emit($event)"
                />
              </div>
            }
          </div>
        </div>

        @if (isArrowVisible()) {
          <button (click)="next()">
            <svg class="carousel-arrow carousel-arrow-next"
                 version="1.1" id="Layer_1"
                 xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 viewBox="0 0 495 495" style="enable-background:new 0 0 495 495;" xml:space="preserve">
              <g>
                <polygon
                  style="fill:#f3e1bd;"
                  points="247.5,197.105 247.5,297.895 297.731,247.5 	"
                />
                <path style="fill:#f8ca68;" d="M247.5,0v140.444L354.208,247.5L247.5,354.556V495C384.19,495,495,384.19,495,247.5
                  S384.19,0,247.5,0z"/>
                <path style="fill:#f3e1bd;" d="M223.017,379.119l-28.33-28.238l52.813-52.986V197.105l-52.813-52.986l28.33-28.238l24.483,24.563V0
                  C110.81,0,0,110.81,0,247.5S110.81,495,247.5,495V354.556L223.017,379.119z"/>
                <polygon style="fill:#ffffff;" points="194.687,144.119 247.5,197.105 297.731,247.5 247.5,297.895 194.687,350.881
                  223.017,379.119 247.5,354.556 354.208,247.5 247.5,140.444 223.017,115.881 	"/>
              </g>
            </svg>
          </button>
        }

        @if (isLoading()) {
          <preloader class="carousel-preloader" />
        }
      </div>

    </div>
  </div>
}
